const summary = "Dropdown-module_summary_Xbsnp-Dg";
const indicator = "Dropdown-module_indicator_oQwHfinM";
const styles = {
  summary,
  indicator
};
export {
  styles as default,
  indicator,
  summary
};
